import {useMemo} from 'react'
import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../../../../services/AppsService'
import {AmoCRMUsersInServiceHeader} from './AmoCRMUsersInServiceHeader'
import {OneUserInServiceAmoCRM} from './OneUserInServiceAmoCRM'

const AmoCRMUsersInService = () => {
  const {appId} = useParams()
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)
  const users = app?.settings.amocrm.users

  const sortedUsers = useMemo(() => [...(users ?? [])].sort((a, b) => a.amocrm_user_id - b.amocrm_user_id), [users])

  return (
    <table className='table align-middle table-row-dashed fs-7 gy-5 dataTable no-footer'>
      <AmoCRMUsersInServiceHeader />
      <tbody>
        {sortedUsers.map((user) => (
          <OneUserInServiceAmoCRM user={user} key={user.id} />
        ))}
      </tbody>
    </table>
  )
}

export {AmoCRMUsersInService}
